const initState = {
  isLoadingFetchSignature: null,
  isLoadingValidateSignature: null,
  isLoadingFetchSignatureSavingsAccount: null,
  isLoadingValidateSignatureSavingsAccount: null,
  isLoadingFetchOtp: false,
  isLoadingValidateOtp: false,
  isLoadingCreatePassword: false,
  isLoadingContactConsumerCredit: false,
  isLoadingRegisterPersonalData: null,
  isLoadingfetchProductOffers: null,
  isLoadingValidatePersonalData: false,
  isLoadingValidateIdentity: null,
  isLoadingFetchCoverage: false,
  isLoadingPreferences: false,
  isLoadingAdditional: false,
  isLoadingFetchExecutive: null,
  isLoadingRegisterSurvey: null,
  isLoadingDocuments: {
    isLoading: false,
    name: '',
  },
  isLoadingGeneratePaymentButton: null,
  isLoadingConfirmPaymentButton: null,
};

export default initState;
